import * as React from "react";
import classnames from "classnames";
import * as styles from "./styles.scss";

interface IListProps {
  children: React.ReactNode;
  noMargin?: boolean;
  listStyle?: boolean;
}

interface IListItemProps {
  children: React.ReactNode;
  noBorder?: boolean;
  type?: "danger" | "success";
  fullPadding?: boolean;
  verticalPadding?: boolean;
  cutter?: boolean;
  hidden?: boolean;
}

const ListItem = ({
  noBorder,
  children,
  type,
  fullPadding,
  verticalPadding,
  cutter,
  hidden
}: IListItemProps) => {
  const className = classnames({
    [styles.ListItem]: true,
    [styles.noBorder]: noBorder,
    [styles.cutter]: cutter,
    [styles.danger]: type === "danger",
    [styles.success]: type === "success",
    [styles.fullPadding]: fullPadding,
    [styles.verticalPadding]: verticalPadding,
    [styles.hidden]: hidden,
  });

  return <div className={className}>{children}</div>;
};

export class List extends React.Component<IListProps, {}> {
  public static Item = ListItem;

  render() {
    const { children } = this.props;

    return <>{children}</>;
  }
}
